import { BoxProps, Center, Icon } from '@wegroup/design-system';
import React from 'react';

interface Props {
  isChecked: boolean;
  onChange: (value: boolean) => void;
  isDisabled?: boolean;
}

const TableCheckbox: React.FC<Props & Omit<BoxProps, 'onChange'>> = ({
  isChecked,
  onChange,
  isDisabled,
  ...props
}) => {
  return (
    <Center
      borderRadius="sm"
      border="2px"
      cursor="pointer"
      flexShrink="0"
      borderColor={isChecked && !isDisabled ? 'primary.500' : 'gray.100'}
      w="4"
      h="4"
      bg={isDisabled ? 'gray.100' : isChecked ? 'primary.500' : 'white'}
      onClick={() => onChange(!isChecked)}
      _hover={{
        borderColor: isChecked ? 'primary.600' : 'primary.500',
        bg: isChecked ? 'primary.600' : 'white',
      }}
      pointerEvents={isDisabled ? 'none' : 'auto'}
      {...props}
    >
      {isChecked && (
        <Icon
          name="GeneralStatusSuccessCheckmark"
          boxSize="4"
          color={isDisabled ? 'gray.300' : 'white'}
        />
      )}
    </Center>
  );
};

export default TableCheckbox;
